import React from 'react';
import { NavLink } from 'react-router-dom';
import { navItems } from './Sidebar';
export function MobileNav() {
  return <nav aria-label="Main" className="flex-none border-t border-ink-line bg-ink-panel md:hidden" data-id="element-59" data-mp="1x93q3sl2rrge">
      <ul className="flex" data-id="element-60" data-mp="1ja446soy5qnx">
        {navItems.map(({
        to,
        label,
        Icon
      }) => <li key={to} className="flex-1" data-id="element-61" data-mp="1naxolc36knc2">
            <NavLink to={to} end={to === '/'} className={({
          isActive
        }) => `flex flex-col items-center gap-1 py-2.5 text-[10px] transition-colors duration-150 ease-night focus:outline-none focus-visible:ring-2 focus-visible:ring-iris-soft ${isActive ? 'text-gold' : 'text-muted'}`} data-id="element-62" data-mp="1ne3gez3723bh">
              <Icon className="h-5 w-5" aria-hidden="true" data-id="element-63" data-mp="qlzs9pfs8hcs" />
              {label === 'Your Library' ? 'Library' : label === 'Now Playing' ? 'Playing' : label === 'Favourites' ? 'Saved' : label}
            </NavLink>
          </li>)}
      </ul>
    </nav>;
}